module.exports = __webpack_public_path__ + "img/14c4891.jpg";